const clarityFlag = "__CLARITY_INITIALIZED__";
const clarityVisibilityFlag = "__CLARITY_VISIBILITY_LISTENER__";
const clarityDeferredFlag = "__CLARITY_DEFERRED_LISTENER__";

const handleVisibility = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (!window.clarity) return;
  if (document.visibilityState === "visible") {
    window.clarity("start");
  } else {
    window.clarity("stop");
  }
};

const hasUserActivated = () => {
  if (typeof navigator !== "undefined" && navigator.userActivation) {
    return navigator.userActivation.hasBeenActive;
  }
  if (typeof document !== "undefined" && document.hasFocus) {
    return document.hasFocus();
  }
  return false;
};

const injectClarity = (projectId) => {
  if (window[clarityFlag]) return true;
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", projectId);
  window[clarityFlag] = true;

  if (!window[clarityVisibilityFlag]) {
    document.addEventListener("visibilitychange", handleVisibility);
    handleVisibility(); // set initial state
    window[clarityVisibilityFlag] = true;
  }
  return true;
};

const initClarity = (projectId) => {
  if (typeof window === "undefined" || typeof document === "undefined")
    return false;
  if (!projectId) return false;
  if (window[clarityFlag]) return true;

  const readyToLoad =
    document.visibilityState === "visible" && hasUserActivated();
  if (readyToLoad) {
    return injectClarity(projectId);
  }

  if (window[clarityDeferredFlag]) return false;
  window[clarityDeferredFlag] = true;

  const maybeInit = () => {
    const canLoad =
      document.visibilityState === "visible" && hasUserActivated();
    if (!canLoad) return;
    removeListeners();
    injectClarity(projectId);
  };

  const interactions = [
    "pointerdown",
    "touchstart",
    "keydown",
    "scroll",
    "visibilitychange",
    "pageshow",
  ];

  const listenerOpts = false; // consistent add/remove

  const removeListeners = () => {
    interactions.forEach((evt) =>
      document.removeEventListener(evt, maybeInit, listenerOpts)
    );
  };

  interactions.forEach((evt) =>
    document.addEventListener(evt, maybeInit, listenerOpts)
  );

  return false;
};

export { initClarity, handleVisibility };
